import { render, staticRenderFns } from "./AdminLeaderboardElement.vue?vue&type=template&id=8dbb42c2&scoped=true"
import script from "./AdminLeaderboardElement.vue?vue&type=script&lang=js"
export * from "./AdminLeaderboardElement.vue?vue&type=script&lang=js"
import style0 from "./AdminLeaderboardElement.vue?vue&type=style&index=0&id=8dbb42c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbb42c2",
  null
  
)

export default component.exports